<script lang="ts">
	import Footer from "$lib/components/footer.svelte";
	import Header from "$lib/components/header.svelte";
	import { initHomeSwiper, initVenueSwiper, initSwiperVid, destroySwiper } from "$lib/js/swiper.js";
	import { onDestroy, onMount } from "svelte";
	import { page } from '$app/stores';
	import { _ } from 'svelte-i18n';
	// import Swiper, { Navigation } from 'swiper';
	// import 'swiper/css';
	// import 'swiper/css/navigation';

	const lang = $page.params.locale;
	const currentPath = $page.url.pathname.replace(`/${$page.params.locale}`, '');

	export let data;
	let info = data.info;
	// console.log('General Data', info);

	let venue = data?.venue;
	// console.log('data server', venue);

	let events = data?.event;
	// console.log('data events', events);
	let packages = data?.packages;
	let testimony = data?.testimonial;
	// console.log('data testimonial', testimony);

	onMount(() =>{
		initHomeSwiper();
		initVenueSwiper();
	});

	// Function to handle the scroll behavior
	function scrollToSection(event) {
		event.preventDefault(); // Prevent default behavior
		const section2 = document.getElementById('homeIntro');
		if (section2) {
		section2.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to section2
		}
	}

	let modalGoodMeeting;

	// let videoElement;
	// let isPlaying = false;

	// function playVideo() {
	// 	videoElement.play();
	// 	isPlaying = true;
	// }

	/* ——— sumber video ——— */
	const videos = [
		'/videos/sinar-mas-group.webm',
		'/videos/vara-wedding-vijay&ritika.webm',
		'/videos/showtime.webm',
		'/videos/motherson.webm'
		// tambah lagi di sini
	];

	/* ——— state ——— */
	// let videoEls: HTMLVideoElement[] = [];   // otomatis terisi oleh bind:this
	let playingIndex = -1;
	let videoEls: HTMLVideoElement[] = [];

	function play(index: number) {
		if (playingIndex !== -1 && playingIndex !== index) stopVideo(playingIndex);
		videoEls[index]?.play();
		playingIndex = index;
	}

	function stopVideo(index: number) {
		const v = videoEls[index];
		if (v) {
			v.pause();
			v.currentTime = 0;
		}
		if (playingIndex === index) playingIndex = -1;
	}

	onMount(() => {
		destroySwiper();
		initSwiperVid('.mySwiperVidreview', () => {
			if (playingIndex !== -1) stopVideo(playingIndex);
		});
	});

	onDestroy(() => {
		destroySwiper();
	});
</script>

<svelte:head>
	<title>Jimbaran Convention Center</title>
	<meta name="description" content="Jimbaran Convention Center" />
</svelte:head>


<Header info={info} />
<section class="relative h-[calc(100vh-8vh-70px)]">
	<!-- <video src="https://jccweb.b-cdn.net" autoplay loop muted playsinline  class="w-full h-full object-cover object-center"></video> -->
	<video src="/videos/jcc-video.webm" autoplay loop muted playsinline  class="w-full h-full object-cover object-center"></video>
	<div class="absolute h-full w-full top-0 left-0 font-primary text-white flex items-end justify-center z-[2]
                    after:content-[''] after:absolute after:bottom-0 after:block after:bg-gradient-bottom after:w-full after:h-[40%]">
          <div class="text-content text-center  mb-[30px] sm:mb-[30px] relative z-10">
			<!-- svelte-ignore a11y_consider_explicit_label -->
			<!-- svelte-ignore a11y_invalid_attribute -->
			<a href="#" on:click={scrollToSection} class="flex flex-col items-center justify-between  px-3 py-2 text-white tracking-wider">
				<svg class="w-10 h-10 animate-bounce" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#ffffff" viewBox="0 0 256 256"><path d="M213.66,130.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,204.69l74.34-74.35A8,8,0,0,1,213.66,130.34Zm-91.32,11.32a8,8,0,0,0,11.32,0l80-80a8,8,0,0,0-11.32-11.32L128,124.69,53.66,50.34A8,8,0,0,0,42.34,61.66Z"></path></svg>
				<p class="uppercase animate-bounce">{$_('explore')}</p>
		  	</a>
          </div>
    </div>
</section>


<section id="homeIntro" class="pt-[6rem] pb-[3rem] relative">
	<img src="/images/bg-primary.webp" class="absolute top-0 w-full h-[70%] object-cover object-bottom" alt="images">
	<div class="container relative mb-[8rem]">
		<div class="flex flex-col-reverse sm:grid grid-cols-2 sm:pl-[10vw] lg:pl-[4vw] xl:pl-[5vw] 2xl:pl-[5vw] items-center">
			<div class="mt-[3rem] sm:mt-[unset]" data-aos="fade-right" data-aos-duration="1500">
				<h1 class="uppercase font-secondary 2xl:text-[2.5rem] xl:text-[2rem] lg:text-[2rem] md:text-[1.8rem] text-[1.5rem] leading-[120%] mb-[15px] sm:mb-[20px] text-center sm:text-left">{@html $_('home-welcome')}</h1>
				<h2 class="font-primary font-light text-[1.2rem] leading-[120%] mb-[25px] text-center sm:text-left">{$_('home-welcome-desc')}</h2>
				<div class="flex lg:flex-row flex-col justify-center items-center sm:justify-start lg:gap-4 gap-2">
					<a href="/{$page.params.locale}/contact" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white max-w-max">{$_('home-start-plan')}</a>
					<!-- <a href="https://bali.intercontinental.com/wp-content/uploads/2024/04/MICE-brochure.pdf" target="_blank" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white max-w-max">BROCHURE</a> -->
				</div>
			</div>
			<div class="relative" data-aos="fade-left" data-aos-duration="1500">
				<span class="block absolute top-[5%] sm:top-[30px] sm:left-[calc(20%-30px)] w-[90%] sm:w-[70%] aspect-[.8] border border-primary z-[1]"></span>
				<span class="block absolute top-[3%] sm:top-[15px] left-[2.2%] sm:left-[calc(20%-15px)] w-[90%] sm:w-[70%] aspect-[.8] border border-primary z-[1]"></span>
				<!-- <span class="block absolute top-[5%] sm:top-[30px] sm:left-[calc(20%-17px)] w-[90%] sm:w-[68%] aspect-[.8] border-l border-b border-primary z-[1]"></span> -->
				<div class="aspect-[.8] mx-auto sm:mx-[unset] w-[90%] sm:w-[70%] overflow-hidden sm:ml-[20%] relative z-[2]">
					<img src="/images/venue/loggia-1440x1080.webp" class="h-full w-full object-cover object-center" alt="images">
				</div>
			</div>
		</div>
	</div>
	<div class="container relative mb-[10rem]">
		<div class="flex flex-col sm:grid grid-cols-2 items-end sm:gap-10 ">
			<div class="relative" data-aos="fade-left" data-aos-duration="1500">
				<span class="block absolute top-[5%] sm:top-[15px] left-[8%] sm:left-[17.5%] w-[90%] sm:w-[70%] aspect-[16/12] border border-primary z-[1]"></span>
				<span class="block absolute top-[8%] sm:top-[30px] left-[10%] sm:left-[20.5%] w-[90%] sm:w-[70%] aspect-[16/12] border border-primary z-[1]"></span>
				<div class="aspect-[16/12] mx-auto sm:mx-[unset] w-[90%] sm:w-[70%] overflow-hidden sm:ml-[15%] relative z-[2]">
					<img src="images/meeting-for-good1.webp" class="h-full w-full object-cover object-center" alt="images">
				</div>
			</div>
			<div class="mt-[3rem] sm:mt-[unset]" data-aos="fade-right" data-aos-duration="1500">
				<p class="uppercase font-secondary text-[1.5rem] 2xl:text-[2rem] xl:text-[2rem] leading-[120%] mb-[15px] sm:mb-[20px] text-center sm:text-left">{$_('home-meeting-good')}</p>
				<p class="font-primary font-light text-[1.2rem] leading-[120%] mb-[25px] text-center sm:text-left">{$_('home-meeting-good-desc')}</p>
				<div class="flex justify-center sm:justify-start">
					<!-- <button class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] hidden sm:inline-block transition-all duration-300 hover:bg-primary hover:text-white" on:click={() => modalGoodMeeting.showModal()}>Read More</button> -->
					<a data-sveltekit-reload href="/{$page.params.locale}/meeting-for-good" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white">{$_('read-more')}</a>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal -->
	<dialog bind:this={modalGoodMeeting} id="my_modal_3" class="modal font-primary">
		<div class="modal-box rounded-none font-primary flex flex-col relative max-w-[80vw] h-[80vh]">
			<form method="dialog" class="flex justify-between items-center border-b mb-2 absolute top-0 right-1">
				<button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
			</form>
			<div class="modal-content overflow-y-auto flex-1 py-4">
				<!-- <embed src="/pdf/meeting-for-good.pdf" type="application/pdf" width="100%" height="600px"> -->
				<!-- svelte-ignore a11y_missing_attribute -->
				<iframe src="/pdf/meeting-for-good.pdf" width="100%" height="100%"></iframe>
			</div>		
		</div>
	</dialog>


	<div class="container relative pb-[20px]">
		<div class="sm:px-[10vw]" data-aos="fade-up" data-aos-duration="1000">
			<div class="flex items-center gap-5">
				<span class="w-full h-[1px] bg-secondary block"></span>
				<p class="font-secondary text-primary 2xl:text-[2rem] xl:text-[2rem] lg:text-[1.8rem] md:text-[1.8rem] text-[1.5rem] leading-[120%] uppercase whitespace-nowrap">{$_('home-events')}</p>
				<span class="w-full h-[1px] bg-secondary block"></span>
			</div>
			<p class="font-primary text-base text-primary text-center">{$_('home-events-desc')}</p>
			<!-- <div>
				<a href="/venues" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white">See All Venues</a>
			</div> -->
		</div>
	</div>

	<div class="absolute w-full h-[15%] bottom-0 bg-[#DAD9D6] block"></div>
	<div class="container relative" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
		<div class="swiper mySwiperHomeVenue">
			<div class="swiper-wrapper">
				{#each events as item}
				<div class="swiper-slide">
					<a data-sveltekit-reload href="/{$page.params.locale}/events/{item.slug}" class="flex flex-col group ">
						<div class="w-full aspect-[16/11] overflow-hidden">
							<img src="{item.featured_images[0].path}" class="w-full h-full object-cover object-center transition-all duration-300 group-hover:scale-125" alt="images">
						</div>
						<div class=" w-full h-full flex flex-col justify-end text-primary">
							<div class="w-full px-[20px] py-[20px]">
								<p class="text-center font-secondary text-[1rem] mb-[10px]">{@html item.name}</p>
								<p class="font-primary text-center line-clamp-3 text-[.9rem] leading-[120%]">{item.excerpt}</p>
							</div>
						</div>
					</a>
				</div>
				{/each}
	
			</div>
			<div class="swiper-button-next after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div>
	</div>

</section>

<!-- Home Venue  -->
<section class="py-[4rem] relative">
	<div class="container relative mb-[40px]">
		<div class="sm:px-[10vw]" data-aos="fade-up" data-aos-duration="1000">
			<div class="flex items-center gap-5">
				<span class="w-full h-[1px] bg-secondary block"></span>
				<p class="font-secondary text-primary 2xl:text-[2rem] xl:text-[2rem] lg:text-[1.8rem] md:text-[1.8rem] text-[1.5rem] leading-[120%] uppercase whitespace-nowrap">{$_('home-venues')}</p>
				<span class="w-full h-[1px] bg-secondary block"></span>
			</div>
			<p class="font-primary text-base text-primary sm:w-[600px] block mx-auto mb-5 text-center">{$_('home-venues-desc')}</p>
			<!-- <div class="flex justify-center">
				<a href="/venues" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white">Diverse Venue Options</a>
			</div> -->
		</div>
	</div>
	<div class="container" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="bottom">
		<!-- <img src="/images/bg-venue1.webp" alt="Jimbaran Convention Center" class="aspect-square sm:aspect-[16/7] object-cover object-bottom w-full"> -->
		<div class="swiper mySwiperVenueImage !rounded-xl">
			<div class="swiper-wrapper">
				<div class="swiper-slide">
				  <img src="/images/gm-conference.webp" class="aspect-square sm:aspect-[16/7] object-cover object-bottom w-full" alt="images" loading="lazy">
				</div>
				<div class="swiper-slide">
					<img src="/images/sunset-garden.webp" class="aspect-square sm:aspect-[16/7] object-cover object-bottom w-full" alt="images" loading="lazy">
				</div>
				<div class="swiper-slide">
					<img src="/images/wedding-setup.webp" class="aspect-square sm:aspect-[16/7] object-cover object-bottom w-full" alt="images" loading="lazy">
				</div>
			</div>
			<div class="swiper-button-next swiper-button-next-imgvenue rounded-full after:!content-[unset] !w-[40px] !h-[40px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
			  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev swiper-button-prev-imgvenue rounded-full after:!content-[unset] !w-[40px] !h-[40px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
			  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
			<div class="swiper-pagination swiper-pagination-imgvenue !text-white"></div>
		</div>
		<div class="flex justify-center mt-[30px]">
			<a data-sveltekit-reload href="/{$page.params.locale}/venues" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white">{$_('home-venues-link')}</a>
		</div>
		<!-- <div class="swiper mySwiperHomeVenue">
			<div class="swiper-wrapper">
				{#each venue as item}
				<div class="swiper-slide">
					<a data-sveltekit-reload href="/venues/{item.slug}" class="w-full aspect-[.7] overflow-hidden block relative group">
						<img src="{item.featured_images[0].path}" class="w-full h-full object-cover transition-all duration-300 group-hover:scale-125" alt="images">
						<div class="absolute top-0 w-full h-full flex flex-col justify-end bg-gradient-to-b from-transparent to-black">
							<div class="w-full px-[20px] pb-[30px]">
								<p class="text-white text-center uppercase font-secondary text-[1.1rem] leading-[120%] mb-[10px]">{item.name}</p>
								<ul class="font-primary flex justify-center gap-3 py-[20px]">
									<li class="flex items-center text-[.8rem] px-[8px] py-[5px] text-white gap-1  bg-white/30 rounded-[15px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white/30">
										<svg xmlns="http://www.w3.org/2000/svg" class="fill-white" width="15" height="15" viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path></svg>
										<p class="italic">{item.type}</p>
									</li>
									<li class="flex items-center text-[.8rem] px-[8px] py-[5px] text-white gap-1  bg-white/30 rounded-[15px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white/30">
										<svg xmlns="http://www.w3.org/2000/svg" class="fill-white" width="15" height="15" viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path></svg>
										<p class="italic">Max Capacity: {item.feature.capacity}</p>
									</li>
								</ul>
								<p class="font-primary font-light text-center text-white leading-[120%] line-clamp-3 text-[.9rem]">{item.excerpt}</p>
							</div>
						</div>
					</a>
				</div>
				{/each}
	
			</div>
			<div class="swiper-button-next after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div> -->
	</div>
</section>

<!-- Intercontinental Detail  -->
<section class="bg-[#DAD9D6] py-[5rem] relative">
	<!-- <div class="absolute bg-[#DAD9D6] block h-[50%] w-full top-0"></div> -->
	<div class="container px-[5vw] relative aos-item" data-aos="zoom-in" data-aos-duration="1000">
		<div class="swiper mySwiperIntercon">
			<div class="swiper-wrapper">
			  <div class="swiper-slide">
				<img src="/images/intercontinental/photo1.webp" class="w-full aspect-[.9] sm:aspect-video object-center object-cover" width="300" height="300" alt="images">
			  </div>
			  <div class="swiper-slide">
				<img src="/images/intercontinental/photo2.webp" class="w-full aspect-[.9] sm:aspect-video object-center object-cover" width="300" height="300" alt="images">
			  </div>
			  <div class="swiper-slide">
				<img src="/images/intercontinental/photo3.webp" class="w-full aspect-[.9] sm:aspect-video object-center object-cover" width="300" height="300" alt="images">
			  </div>
			  <div class="swiper-slide">
				<img src="/images/intercontinental/photo4_1.webp" class="w-full aspect-[.9] sm:aspect-video object-center object-cover" width="300" height="300" alt="images">
			  </div>
			  <div class="swiper-slide">
				<img src="/images/intercontinental/photo5_1.webp" class="w-full aspect-[.9] sm:aspect-video object-center object-cover" width="300" height="300" alt="images">
			  </div>
			</div>
			<div class="swiper-button-next fill-white after:!content-[unset] !w-[50px] !h-[50px] !hidden sm:!flex">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev fill-white after:!content-[unset] !w-[50px] !h-[50px] !hidden sm:!flex">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div>
		<div class="text-primary text-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[2] w-[80%] sm:w-[60%] aspect-video py-[20px] sm:py-[40px] px-[20px] sm:px-[60px] bg-white/85 flex flex-col justify-center">
			<p class="font-secondary 2xl:text-[2rem] xl:text-[2rem] lg:text-[1.8rem] md:text-[1.8rem] text-[1.5rem] leading-[120%] uppercase mb-3">{$_('home-intercon-title')}</p>
			<p class="font-primary text-[.9rem] sm:text-base">{$_('home-intercon-desc')}</p>
			<div class="mt-[20px]">
				<a href="https://bali.intercontinental.com/" target="_blank" class="uppercase border border-primary py-[10px] px-[20px] transition-all duration-300 hover:bg-primary hover:text-white">{$_('learn-more')}</a>
			</div>
		</div>
	</div>
</section>

<!-- <section class="mt-10 mb-[5rem]">
	<div class="container sm:px-[10vw] pb-[5rem] aos-item" data-aos="fade-in" data-aos-duration="1000">
		<div class="flex items-center gap-5">
			<span class="w-full h-[1px] bg-secondary block"></span>
			<p class="font-secondary text-primary text-[1.8rem] sm:text-[2.5rem] leading-[120%] uppercase sm:whitespace-nowrap hidden sm:block">Past Events</p>
			<p class="font-secondary text-primary text-[1.8rem] sm:text-[2.5rem] leading-[120%] uppercase whitespace-nowrap block sm:hidden">Past Events</p>
			<span class="w-full h-[1px] bg-secondary block"></span>
		</div>
		<p class="font-primary text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.</p>
	</div>
	<div class="relative py-[3rem] aos-item" data-aos="fade-in" data-aos-duration="1000">
		<div class="absolute top-0 bottom-0 w-[40%] bg-[#dad9d6] block"></div>
		<div class="swiper mySwiperHomeEvent">
			<div class="swiper-wrapper">
				{#each events as item}
				<div class="swiper-slide">
					<div class="flex flex-col sm:grid grid-cols-2 items-center">
						<div class="aspect-[11/9] w-full px-[10px] sm:px-[unset]">
							<img src="{item.featured_images[0].path}" class="h-full w-full object-cover object-center" alt="Jimbaran Convention Center - Past Evets">
						</div>
						<div class="bg-white shadow-[10px_10px_50px_0px_rgba(0,0,0,0.15)] w-[90%] sm:w-full 2xl:h-[50%] xl:h-[50%] lg:h-[60%] p-[30px] text-primary flex flex-col justify-center gap-[20px] sm:-ml-[20%] mx-auto sm:mx-[unset] -mt-[20%] sm:!-mt-0">
							<div>
								<p class="font-secondary text-[1.8rem] mb-[20px] leading-[120%]">{item.name}</p>
								<p class="font-secondary text-[.9rem]">{item.excerpt}</p>
							</div>
							<div>
								<a data-sveltekit-reload href="/events" class="uppercase font-primary text-secondary relative after:content-[''] after:absolute after:block after:left-0 after:-bottom-[6px] after:h-[2px] after:bg-secondary after:w-0 after:transition-all after:!duration-300 after:!ease-in-out hover:after:w-full">Read More</a>
							</div>
						</div>
					</div>
				</div>
				{/each}
			

			</div>
			<div class="swiper-button-next after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !right-16 transition-all duration-300 hover:bg-white hover:fill-primary !top-[25%] sm:!top-[50%]">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev after:!content-[unset] !w-[50px] !h-[50px] fill-white border bg-primary/30 backdrop-blur-[10px] border-white !left-16 transition-all duration-300 hover:bg-white hover:fill-primary !top-[25%] sm:!top-[50%]">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div>
	</div>
</section> -->

<section class="py-[6rem] aos-item" data-aos="fade-right" data-aos-anchor-placement="bottom-bottom">
	<div class="container">
		<div class="border border-primary w-full px-[20px] py-[30px] sm:p-[50px] relative">
			<p class="absolute font-secondary 2xl:text-[1.5rem] xl:text-[1.5rem] lg:text-[1.5rem] md:text-[1.5rem] text-[1.5rem] text-primary bg-white px-[10px] -top-[20px] left-[50%] -translate-x-[50%] sm:left-[11%] text-center whitespace-nowrap">{$_('home-meeting-essential')}</p>
			<ul class="font-secondary flex flex-wrap justify-start gap-[10px] sm:gap-[20px]">
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M27.2,126.4a8,8,0,0,0,11.2-1.6,52,52,0,0,1,83.2,0,8,8,0,0,0,11.2,1.59,7.73,7.73,0,0,0,1.59-1.59h0a52,52,0,0,1,83.2,0,8,8,0,0,0,12.8-9.61A67.85,67.85,0,0,0,203,93.51a40,40,0,1,0-53.94,0,67.27,67.27,0,0,0-21,14.31,67.27,67.27,0,0,0-21-14.31,40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,25.6,115.2,8,8,0,0,0,27.2,126.4ZM176,40a24,24,0,1,1-24,24A24,24,0,0,1,176,40ZM80,40A24,24,0,1,1,56,64,24,24,0,0,1,80,40ZM203,197.51a40,40,0,1,0-53.94,0,67.27,67.27,0,0,0-21,14.31,67.27,67.27,0,0,0-21-14.31,40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,25.6,219.2a8,8,0,1,0,12.8,9.6,52,52,0,0,1,83.2,0,8,8,0,0,0,11.2,1.59,7.73,7.73,0,0,0,1.59-1.59h0a52,52,0,0,1,83.2,0,8,8,0,0,0,12.8-9.61A67.85,67.85,0,0,0,203,197.51ZM80,144a24,24,0,1,1-24,24A24,24,0,0,1,80,144Zm96,0a24,24,0,1,1-24,24A24,24,0,0,1,176,144Z"></path></svg>
					<p class="text-[.9rem] sm:text-base !leading-[120%]">{$_('home-meeting-item-1')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176Z"></path></svg>
					<p class="text-[.9rem] sm:text-base !leading-[120%]">{$_('home-meeting-item-2')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,32H192V224H160V184a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H64Zm80,192H112V192h32ZM88,64a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64ZM88,104a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104ZM88,144a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,144Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%] !leading-[120%]">{$_('home-meeting-item-3')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%] !leading-[120%]">{$_('home-meeting-item-4')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M254.3,107.91,228.78,56.85a16,16,0,0,0-21.47-7.15L182.44,62.13,130.05,48.27a8.14,8.14,0,0,0-4.1,0L73.56,62.13,48.69,49.7a16,16,0,0,0-21.47,7.15L1.7,107.9a16,16,0,0,0,7.15,21.47l27,13.51,55.49,39.63a8.06,8.06,0,0,0,2.71,1.25l64,16a8,8,0,0,0,7.6-2.1l55.07-55.08,26.42-13.21a16,16,0,0,0,7.15-21.46Zm-54.89,33.37L165,113.72a8,8,0,0,0-10.68.61C136.51,132.27,116.66,130,104,122L147.24,80h31.81l27.21,54.41ZM41.53,64,62,74.22,36.43,125.27,16,115.06Zm116,119.13L99.42,168.61l-49.2-35.14,28-56L128,64.28l9.8,2.59-45,43.68-.08.09a16,16,0,0,0,2.72,24.81c20.56,13.13,45.37,11,64.91-5L188,152.66Zm62-57.87-25.52-51L214.47,64,240,115.06Zm-87.75,92.67a8,8,0,0,1-7.75,6.06,8.13,8.13,0,0,1-1.95-.24L80.41,213.33a7.89,7.89,0,0,1-2.71-1.25L51.35,193.26a8,8,0,0,1,9.3-13l25.11,17.94L126,208.24A8,8,0,0,1,131.82,217.94Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%] !leading-[120%]">{$_('home-meeting-item-5')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 256 256"><path d="M80,56V24a8,8,0,0,1,16,0V56a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,120,64Zm32,0a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,152,64Zm96,56v8a40,40,0,0,1-37.51,39.91,96.59,96.59,0,0,1-27,40.09H208a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H56.54A96.3,96.3,0,0,1,24,136V88a8,8,0,0,1,8-8H208A40,40,0,0,1,248,120ZM200,96H40v40a80.27,80.27,0,0,0,45.12,72h69.76A80.27,80.27,0,0,0,200,136Zm32,24a24,24,0,0,0-16-22.62V136a95.78,95.78,0,0,1-1.2,15A24,24,0,0,0,232,128Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%]">{$_('home-meeting-item-6')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50"  viewBox="0 0 256 256"><path d="M72,88V40a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0ZM216,40V224a8,8,0,0,1-16,0V176H152a8,8,0,0,1-8-8,268.75,268.75,0,0,1,7.22-56.88c9.78-40.49,28.32-67.63,53.63-78.47A8,8,0,0,1,216,40ZM200,53.9c-32.17,24.57-38.47,84.42-39.7,106.1H200ZM119.89,38.69a8,8,0,1,0-15.78,2.63L112,88.63a32,32,0,0,1-64,0l7.88-47.31a8,8,0,1,0-15.78-2.63l-8,48A8.17,8.17,0,0,0,32,88a48.07,48.07,0,0,0,40,47.32V224a8,8,0,0,0,16,0V135.32A48.07,48.07,0,0,0,128,88a8.17,8.17,0,0,0-.11-1.31Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%] !leading-[120%]">{$_('home-meeting-item-7')}</p>
				</li>
				<li class="w-[calc(50%-20px)] sm:w-[calc(100%/3-20px)] flex items-center gap-3 ">
					<svg class="h-[30px] w-[30px] sm:w-[50px] sm:h-[50px] p-[5px] sm:p-[10px] rounded-full bg-[#dad9d6] fill-primary" xmlns="http://www.w3.org/2000/svg" width="50" height="50"  viewBox="0 0 256 256"><path d="M140,204a12,12,0,1,1-12-12A12,12,0,0,1,140,204ZM237.08,87A172,172,0,0,0,18.92,87,8,8,0,0,0,29.08,99.37a156,156,0,0,1,197.84,0A8,8,0,0,0,237.08,87ZM205,122.77a124,124,0,0,0-153.94,0A8,8,0,0,0,61,135.31a108,108,0,0,1,134.06,0,8,8,0,0,0,11.24-1.3A8,8,0,0,0,205,122.77Zm-32.26,35.76a76.05,76.05,0,0,0-89.42,0,8,8,0,0,0,9.42,12.94,60,60,0,0,1,70.58,0,8,8,0,1,0,9.42-12.94Z"></path></svg>
					<p class="text-[.9rem] sm:text-base w-[80%] !leading-[120%]">{$_('home-meeting-item-8')}</p>
				</li>
			</ul>
		</div>
	</div>
</section>

<!-- <section class="pb-[2rem] sm:pb-[5rem] static aos-item" data-aos="fade-left" data-aos-duration="1000">
	<div class="container relative mb-[3rem]">
		<div class="sm:px-[10vw]">
			<div class="flex items-center gap-5">
				<span class="w-full h-[1px] bg-secondary block"></span>
				<p class="font-secondary text-primary 2xl:text-[2rem] xl:text-[2rem] lg:text-[1.8rem] md:text-[1.8rem] text-[1.5rem] leading-[120%] uppercase sm:whitespace-nowrap">Offers</p>
				<span class="w-full h-[1px] bg-secondary block"></span>
			</div>
			<p class="font-primary text-base text-primary text-center mb-[20px]">Enjoy our exclusive offers, tailored to create unforgettable experiences for your special occasions.</p>
			<div class="hidden sm:flex justify-center">
				<a href="/offers" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white">Explore</a>
			</div>
			<div class="sm:hidden flex justify-center gap-2 h-full">	
				<div class="swiper-button-prev swiper-button-prev-package after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-left-[10px] transition-all duration-300 !static !mt-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
				</div>
				<div class="swiper-button-next swiper-button-next-package after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-right-[10px] transition-all duration-300 !static !mt-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
				</div>
			</div>
		</div>
	</div>
	<div class="container relative">
		<div class="swiper mySwiperHomePackage">
			<div class="swiper-wrapper">
				{#each packages as item}
				<div class="swiper-slide">
					<div class="w-full aspect-[16/11] overflow-hidden">
						<img src="{item.featured_images[0].path}" class="w-full h-full object-cover object-center" alt="images">
					</div>
					<div class="p-[20px]">
						<div class="text-primary pb-[20px] text-center sm:text-left">
							<p class="text-[1.1rem] uppercase mb-2 font-secondary tracking-[2px]">{item.name}</p>
							<p class="text-[.9rem] leading-[120%] line-clamp-3 font-light font-primary">{item.excerpt}</p>
						</div>
						<div class="flex justify-center sm:justify-start">
							<a data-sveltekit-reload href="/offers" class="uppercase font-primary text-secondary relative after:content-[''] after:absolute after:block after:left-0 after:-bottom-[6px] after:h-[2px] after:bg-secondary after:w-0 after:transition-all after:!duration-300 after:!ease-in-out hover:after:w-full">View Detail</a>
						</div>
					</div>
				</div>
				{/each}

			</div>
		</div>

		<div class="swiper-button-next swiper-button-next-package after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-right-[10px] transition-all duration-300 !hidden sm:!block">
			<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
		</div>

		<div class="swiper-button-prev swiper-button-prev-package after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-left-[10px] transition-all duration-300 !hidden sm:!block">
			<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
		</div>
	</div>
</section> -->

<!-- Review  -->
<section class="pt-[4rem] pb-[2rem] sm:pb-0" data-aos="fade-up" data-aos-duration="1000">
	<div class="container px-[10vw] pb-[4rem]">
		<div class="flex items-center gap-5">
			<span class="w-full h-[1px] bg-secondary block"></span>
			<p class="font-secondary text-primary text-[1.8rem] sm:text-[2rem] leading-[120%] uppercase sm:whitespace-nowrap text-center">{$_('home-testimonial')}</p>
			<span class="w-full h-[1px] bg-secondary block"></span>
		</div>
		<p class="font-primary text-center">{$_('home-testimonial-desc')}</p>
	</div>
	<div class="container relative mb-10">
		<div class="swiper mySwiperReview sm:w-[60%]">
			<div class="swiper-wrapper">
				{#each testimony as item}
				<div class="swiper-slide">
					<div class="mb-[3rem]">
						<p class="font-secondary text-[1.1rem] sm:text-[1.3rem] text-center">“{item.title}”</p>
						<img src="/images/5star.svg" class="block mx-auto py-[20px]" alt="images">
						<div class="font-primary text-center text-[.9rem]">{@html item.description}</div>
					</div>
					<div class="font-primary text-center">
						<p class="text-[primary] text-[1.1rem] sm:text-[1.1rem] uppercase">{item.name}</p>
						<p class="text-[#A9A9A9] text-[.9rem]">{item.company}</p>
					</div>
				</div>
				{/each}

			</div>
			
		</div>
		
		<div class="flex justify-center flex-row-reverse gap-2 mt-[1.5rem]">
			<div class="swiper-button-next swiper-button-next-review after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-right-[10px] transition-all duration-300 !static sm:!absolute !mt-0">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
	
			<div class="swiper-button-prev swiper-button-prev-review after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-left-[10px] transition-all duration-300 !static sm:!absolute !mt-0">
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div>
	</div>
</section>
<section class="container">
	<!-- <div class="relative w-full aspect-video ">
		<video
			bind:this={videoElement}
			src="/videos/sinar-mas-group.webm"
			controls={isPlaying}
			class="object-cover object-bottom 2xl:object-center h-full w-full"
			on:ended={() => isPlaying = false}
		></video>
		{#if !isPlaying}
		<div class="cover absolute top-0 left-0 right-0 bottom-0 bg-[#000000]/80 flex justify-center items-center flex-col transition-all duration-300">
			<button class="play-button p-5 border border-white rounded-full mb-2" on:click={playVideo}>
				<svg xmlns="http://www.w3.org/2000/svg" class="fill-white w-[40px] h-[40px]" viewBox="0 0 256 256"><path d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"></path></svg>
			</button>
			<p class=" font-primary text-white text-[1.5rem]">{$_('home-cta-video')}</p>
		</div>
		 {/if}
	</div> -->
	<div class="">

		<div class="swiper mySwiperVidreview">
			<div class="swiper-wrapper">
				{#each videos as src, i}
					<div class="swiper-slide !w-full !shrink-0">
						<div class="relative w-full aspect-[16/11] sm:aspect-video">
							<!-- svelte-ignore a11y_media_has_caption -->
							<!-- svelte-ignore element_invalid_self_closing_tag -->
							<video
								bind:this={videoEls[i]}
								src={src}
								controls
								class="object-cover object-bottom 2xl:object-center h-full w-full"
								on:ended={() => stopVideo(i)}
							/>

							{#if playingIndex !== i}
								<div class="absolute inset-0 bg-black/80 flex flex-col items-center justify-center transition-all duration-300">
									<!-- svelte-ignore a11y_consider_explicit_label -->
									<button
										class="p-3 sm:p-5 border border-white rounded-full mb-2"
										on:click={() => play(i)}
									>
										<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 sm:w-10 sm:h-10 fill-white" viewBox="0 0 256 256"><path d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/></svg>
									</button>
									<p class="font-primary text-white text-[1.1rem] sm:text-[1.5rem]">{$_('home-cta-video')}</p>
								</div>
							{/if}
						</div>
					</div>
				{/each}
			</div>

			<!-- <div class="absolute bottom-[10%] right-[1.5%] z-50 gap-[10px] flex flex-row-reverse">
				<div class="swiper-button-next next-vid after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-right-[10px] transition-all duration-300 !static !mt-0">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
					</div>
					<div class="swiper-button-prev prev-vid after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-left-[10px] transition-all duration-300 !static !mt-0">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
					</div>
			</div> -->
		</div>

		<div class="relative z-50 gap-2 flex flex-row-reverse mt-4 justify-center">
			<div class="swiper-button-next next-vid after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-right-[10px] transition-all duration-300 !static !mt-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
				</div>
				<div class="swiper-button-prev prev-vid after:!content-[unset] !w-[50px] !h-[50px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white !-left-[10px] transition-all duration-300 !static !mt-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
				</div>
		</div>

	</div>
</section>
<section class="py-[3rem]">
	<p class="text-center mb-5 font-primary uppercase">{$_('home-feedback')}</p>
	<div class="flex justify-center">
		<a data-sveltekit-reload href="/{$page.params.locale}/testimony-form"
			class="font-primary group/button relative inline-flex items-center justify-center overflow-hidden rounded-md bg-primary backdrop-blur-lg px-6 py-2 text-base font-normal text-white transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-xl hover:shadow-gray-600/50 border border-white/20"
			>
			<span class="text-base uppercase">{$_('home-feedback-link')}</span>
			<div
				class="absolute inset-0 flex h-full w-full justify-center [transform:skew(-13deg)_translateX(-100%)] group-hover/button:duration-1000 group-hover/button:[transform:skew(-13deg)_translateX(100%)]"
			>
				<div class="relative h-full w-10 bg-white/20"></div>
			</div>
		</a>
	</div>
</section>

<Footer info={info}/>